import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { dictionary } from "pdfmake/build/pdfmake";
const useStyles = makeStyles((theme) => ({
  table: {
    fontFamily: "Amiri-Regular",
    direction: "rtl",
   
  },
  tableRightBorder: {
    ...stElemnt.AF.header,
    fontWeight: "bold",
    paddingTop: "2px",
    paddingBottom:"2px",
    border: "solid 0px",
    border: "solid 0.1px",
  },
  rowHeader: {
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
    paddingTop: "2px",
    paddingBottom:"2px",
    border: "solid 0px",
    border: "solid 0.1px",
  },
  headerrows:{
    ...stElemnt.AF.header,
    backgroundColor: colors.grey[100],
    fontWeight: "bold",
    paddingTop: "2px",
    paddingBottom:"2px",
    border: "solid 0px",
    border: "solid 0.1px",
  },
  rowsStyle:{
    ...stElemnt.AF.cell,
    padding: "0px 1px",
  }

}));
const styla={ 
    ...stElemnt.AF.header,
    backgroundColor: colors.grey[100],
    fontWeight: "bold",
    paddingTop: "2px",
    paddingBottom:"2px",
    border: "solid 0px",
    border: "solid 0.1px",};
export default function BodyCost(props) {
  const { data, title } = props;
  const { t } = useTranslation(["forms"]);

  const classes = useStyles();
  return (
    <TableContainer component={Paper} style={{ paddingTop:"1rem"}}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={styla}
          >
            <TableCell className={classes.tableRightBorder} align="center" colSpan={2}></TableCell>

            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {t("prev-balance")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {" "}
              {t("acc-move")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {t("acc-balance")}
            </TableCell>
          </TableRow>
          <TableRow
          style={{styla}}
          >
            <TableCell className={classes.tableRightBorder} align="center">
              {t("account-code")}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {t("account")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              style={{  ...stElemnt.AF.cell,
                padding: "0px 1px", }}
              align="center"
            >
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}{" "}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id} 
            style={{ ...stElemnt.AF.cell,
                padding: "0px 1px",}}>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_COST_no}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_COST_name}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_open_dept?.toFixed(2)?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
              {row.col_open_credit?.toFixed(2)?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_dept?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_credit?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_balance_dept?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.col_balance_credit?.toFixed(2) ?? "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
